// Playtest notes — public page covering known issues and not-yet-implemented
// gaps for testers. No auth required.

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';

class PlaytestNotesView extends BaseComponent {
  static styles = css`
    :host {
      display: block;
      flex: 1;
    }

    .playtest-notes-view {
      max-width: 760px;
      margin: 0 auto;
      padding: 2rem 1.5rem 4rem;
      color: #212529;
    }

    h1 {
      font-size: 1.75rem;
      margin-bottom: 0.5rem;
    }

    h2 {
      font-size: 1.25rem;
      margin-top: 2.5rem;
      margin-bottom: 0.75rem;
      border-bottom: 1px solid #dee2e6;
      padding-bottom: 0.35rem;
    }

    h3 {
      font-size: 1rem;
      margin-top: 1.5rem;
      margin-bottom: 0.5rem;
    }

    p, li {
      line-height: 1.55;
    }

    .lede {
      color: #495057;
      margin-bottom: 0.5rem;
    }

    .updated {
      color: #6c757d;
      font-size: 0.875rem;
      margin-bottom: 2rem;
    }

    ul {
      padding-left: 1.25rem;
    }

    li + li {
      margin-top: 0.4rem;
    }

    .feature-name {
      font-weight: 600;
    }
  `;

  render() {
    return html`
      <div class="playtest-notes-view">
        <h1>Playtest 1: Combat</h1>
        <p class="lede">
          The first playtest focuses on the combat loop end to
          end: PCs and monsters detecting each other, combat starting, the
          initiative order, attacks (melee, ranged, weapon-mastery effects,
          advantage and disadvantage), the unseen-attacker UX, discovery
          labels, dying and stabilizing, and combat ending.
        </p>
        <p class="lede">
          The page below tracks gaps and bugs we already know about so you
          don't have to re-report them. If you hit something that isn't on
          either list, please report it so we can add it.
        </p>
        <p class="updated">Last updated: 2026-04-28</p>

        <h2>Not Yet Implemented</h2>
        <p>
          These are features that exist in the rules but the game doesn't
          enforce or surface yet. Your character may have them on paper, but
          they won't fire during play.
        </p>

        <h3>Species &amp; Backgrounds</h3>
        <ul>
          <li>
            <span class="feature-name">Stonecunning</span> (Dwarf trait) — the
            +Proficiency to History checks about stonework, and the
            tremorsense reveal of nearby underground passages, are not yet in
            the game.
          </li>
        </ul>

        <h2>Known Issues</h2>
        <p>
          Bugs and rough edges we already know about. Reporting them again is
          fine — duplicate reports help us prioritize.
        </p>
        <ul>
          <li>
            (Add issues here as they come up in playtests.)
          </li>
        </ul>

        <h2>Out of Scope</h2>
        <p>
          Areas we aren't asking testers to evaluate in this round. Feedback
          on these is welcome but won't drive Playtest 1's bug list.
        </p>
        <ul>
          <li>Character creation polish and onboarding flow</li>
          <li>Exploration narrative and longer-form adventure pacing</li>
          <li>Social encounters and non-combat interactions</li>
          <li>Multi-session campaign flow</li>
        </ul>
      </div>
    `;
  }
}

customElements.define('playtest-notes-view', PlaytestNotesView);
